export default __webpack_public_path__ + "static/media/HUD-Effects-Glass Fracture.a90254de.jpg";